import React from 'react';
import AppointmentForm from '../components/AppointmentForm';
import { FiPhoneCall, FiShield, FiCheckSquare, FiInfo, FiCheck } from 'react-icons/fi';
import './AppointmentPage.css';

const AppointmentPage = () => {
  return (
    <div className="apt-page-wrapper">
      {/* Header Banner */}
      <header
        className="apt-header"
        style={{
          backgroundImage: "url('/assets/images/img18.png')",
        }}
      >
        <div className="apt-header-overlay"></div>

        <div className="apt-header-content">
          <h1>Book an Appointment</h1>
          <p>
            Schedule your visit with our expert doctors. Quick, easy, and secure booking.
          </p>
        </div>
      </header>

      <div className="apt-container">
        {/* Left Side: Info Cards */}
        <div className="apt-sidebar-left">

          {/* Card 1: Need Help */}
          <div className="apt-card card-premium">
            <div className="apt-card-icon-wrapper help-icon-bg">
              <FiPhoneCall className="apt-card-icon-new" />
            </div>
            <h3>Need Help?</h3>
            <p className="apt-card-desc">
              If you are facing issues booking online, our support team is here to assist you.
            </p>
            <div className="apt-contact-item-new">
              <span className="contact-label-new">Emergency line</span>
              <a href="tel:108" className="contact-link-new emergency">108 (24/7 Support)</a>
            </div>
            <div className="apt-contact-item-new">
              <span className="contact-label-new">Support Helpline</span>
              <a href="tel:+919373674641" className="contact-link-new">+91 9373-67-4641</a>
            </div>
          </div>

          {/* Card 2: Why Choose Us */}
          <div className="apt-card card-premium">
            <div className="apt-card-icon-wrapper choose-icon-bg">
              <FiShield className="apt-card-icon-new" />
            </div>
            <h3>Why Choose Us?</h3>
            <ul className="apt-list-new">
              <li>
                <FiCheck className="list-check-icon" />
                <span> Experienced Multi-Speciality Doctors</span>
              </li>
              <li>
                <FiCheck className="list-check-icon" />
                <span>Advanced Diagnostics & Modern Operation Theatres</span>
              </li>
              <li>
                <FiCheck className="list-check-icon" />
                <span>24/7 Emergency & Critical Care</span>
              </li>
              <li>
                <FiCheck className="list-check-icon" />
                <span>Cashless Mediclaim & Insurance Support</span>
              </li>
            </ul>
          </div>

          {/* Card 3: Checklist */}
          <div className="apt-card card-premium">
            <div className="apt-card-icon-wrapper checklist-icon-bg">
              <FiCheckSquare className="apt-card-icon-new" />
            </div>
            <h3>Checklist for Visit</h3>
            <ul className="apt-list-new">
              <li>
                <FiInfo className="list-info-icon" />
                <span>Government ID Proof (Aadhaar/PAN)</span>
              </li>
              <li>
                <FiInfo className="list-info-icon" />
                <span>Insurance Card / TPA Details</span>
              </li>
              <li>
                <FiInfo className="list-info-icon" />
                <span>Previous Medical / Lab Reports</span>
              </li>
              <li>
                <FiInfo className="list-info-icon" />
                <span>List of active medications</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="apt-form-section">
          <div className="apt-form-wrapper-new">
            <AppointmentForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentPage;
